// force deploy
import React, { useEffect, useState } from "react";
import AdminLTE, { Sidebar } from "adminlte-2-react";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment-timezone";
import _ from "lodash";
import Login from "./auth/Login";
import AceptarTerminos from "./auth/AceptarTerminos";
import Logout from "./auth/Logout";
import Registro from "./registro/Registro";
import Confirmacion from "./registro/Confirmacion";
import Landing from "./landing/Landing";
import RegistroSuper from "./registro/RegistroSuper";
import CrearInvitacion from "./invitacion/CrearInvitacion";
import InvitacionesList from "./invitacion/InvitacionesList";
import { parseJwt } from "./utils/utils";
import controller from "./registro/duck";
import ChangePass from "./changePass/ChangePass";

import OlvidePass from "./olvidePass/OlvidePass";
import OlvidePassSuperAdmin from "./olvidePass/OlvidePassSuperAdmin";
import ChangePassByToken from "./olvidePass/ChangePassByToken";
import UsuariosList from "./usuarios/UsuariosList";
import CargarHorario from "./horarios/CargarHorario";
import EditHorario from "./horarios/EditHorario";
import AddServicioPadre from "./servicios/AddServicioPadre";
import AddServicioHijo from "./servicios/AddServicioHijo";
import AddProfesional from "./profesionales/AddProfesional";
import AddAmbiente from "./locales/AddAmbiente";
import EditAmbiente from "./locales/EditAmbiente";
import AddLocal from "./locales/AddLocal";
import EditLocal from "./locales/EditLocal";
import Local from "./locales/Local";
import ProfesionalesList from "./locales/ProfesionalesList";
import AmbientesList from "./locales/AmbientesList";
import SugerenciasList from "./locales/SugerenciasList";
import LocalesList from "./locales/LocalesList";
import SucursalesList from "./locales/SucursalesList";
import AusenciasProfesionales from "./locales/AusenciasProfesionales";
import ServiciosPadresList from "./locales/ServiciosPadresList";
import HorariosList from "./locales/HorariosList";
import EditProfesional from "./profesionales/EditProfesional";
import EditServicioHijo from "./servicios/EditServicioHijo";
import CrearReservaHorarios from "./reservas/CrearReservaHorarios";
import CrearReservaRestaurante from "./reservas/CrearReservaRestaurante";
import ReservasList from "./reservas/ReservasList";
import ReservasGeneralList from "./reservas/ReservasGeneralList";

import PlanesList from "./planes/PlanesList";
import AddPlan from "./planes/AddPlan";
import EditPlan from "./planes/EditPlan";
import SuscripcionesByUsuario from "./planes/SuscripcionesByUsuario";
import AddSuscripcion from "./planes/AddSuscripcion";

import SubirImagenes from "./imageUploadV3/SubirImagenes";
import CortarImagenesConcepto from "./imageUploadV3/CortarImagenesConcepto";

import AddAusencia from "./ausencias/AddAusencia";

import ListarNotifTemplates from "./notificacion/ListarNotifTemplates";
import CrearNotifTemplate from "./notificacion/CrearNotifTemplate";
import EditarNotifTemplate from "./notificacion/EditarNotifTemplate";

import ServiciosList from "./servicios/ServiciosList";
import WithAuth from "./utils/WithAuth";
import Calendario from "./landing/Calendario";
import CalendarioProfesionales from "./landing/CalendarioProfesionales";

import SegurosList from "./locales/SegurosList";
import AddSeguro from "./locales/AddSeguro";
import EditSeguro from "./locales/EditSeguro";
import SuscripcionesByLocal from "./planes/SuscripcionesByLocal";

import ReservaDetalle from "./reservas/ReservaDetalle";
import EditSubcategoria from "./servicios/EditSubcategoria";

import SubirImagenesLocal from "./locales/SubirImagenesLocal";
import AddContacto from "./contactos/AddContacto";
import EditContacto from "./contactos/EditContacto";
import ContactosList from "./contactos/ContactosList";
import AddAsistencia from "./contactos/AddAsistencia";
import AsistenciasByGroup from "./contactos/AsistenciasByGroup";
import AsistenciasByDate from "./contactos/AsistenciasByDate";
import PromosList from "./locales/PromosList";
import AddPromo from "./locales/AddPromo";

import LinkConfirmacionByEmail from "./olvidePass/LinkConfirmacionByEmail";

const { Item, UserPanel, Header } = Sidebar;

function App() {
  moment.tz.setDefault("Etc/UTC");
  const dispatch = useDispatch();
  const modelUsuario = useSelector((state) => state.usuario);
  const modelOrganizacion = useSelector((state) => state.organizacionById);

  const modelForceLogout = useSelector((state) => state.forceLogoutReducer);

  const [organizacion, setOrganizacion] = useState(null);
  const [nombre, setNombre] = useState(null);
  const [actualRol, setActualRol] = useState(null);
  const [categoria, setCategoria] = useState(null);
  const [sucursales, setSucursales] = useState(false);
  const [loading, setLoading] = useState(true);
  const [localSelected, setLocalSelected] = useState(null);
  const [categoriaSelected, setCategoriaSelected] = useState(null);
  const localSelectedSession = localStorage.getItem("localSelected");
  const categoriaSelectedSession = localStorage.getItem("categoriaSelected");
  const [imagenPerfil, setImagenPerfil] = useState("/defaultImg.png");

  useEffect(() => {
    setLocalSelected(localSelectedSession);
    setCategoriaSelected(categoriaSelectedSession);
  }, [localSelectedSession, categoriaSelectedSession]);

  useEffect(() => {
    // const data = modelForceLogout?.data?.data?.data;
    // const error = modelForceLogout?.error?.response?.data?.mensaje;
    // if (error) {
    //   setOrganizacion("N/A");
    //   dispatch(controller.duckOrganizacion.actions.clear());
    // }
    // if (data) {
    //   setOrganizacion(data.name);
    //   dispatch(controller.duckOrganizacion.actions.clear());
    // }
    // if (modelForceLogout.forceLogout) {
    //   history.push("/logout");
    // }
  }, [modelForceLogout]);

  useEffect(() => {
    const data = modelOrganizacion?.data?.data?.data;
    const error = modelOrganizacion?.error?.response?.data?.mensaje;

    if (error) {
      setLoading(false);
      setOrganizacion("N/A");
      dispatch(controller.duckOrganizacion.actions.clear());
    }
    if (data) {
 
      setLoading(false);
      setCategoria(data.categoriaId);
      setSucursales(data.sucursales);
      if (data.imagen) {
        setImagenPerfil(data.imagen);
      }
      dispatch(controller.duckOrganizacion.actions.clear());
    }
  }, [modelOrganizacion]);

  useEffect(() => {
    const data = modelUsuario?.data?.data?.data;
    const error = modelUsuario?.error?.response?.data?.mensaje;
    if (error) {
      setNombre("N/A");
      dispatch(controller.duckUsuario.actions.clear());
    }
    if (data) {
      const nombrePartido = data.nombre.split(" ");
      setNombre(nombrePartido[0]);
      setOrganizacion(data.organizacionID);

      if (data.organizacionID && data.organizacionID !== "Particular") {
        dispatch(controller.organizacionByIdThunk(data.organizacionID));
      } else {
        setLoading(false);
      }

      dispatch(controller.duckUsuario.actions.clear());
    }
  }, [modelUsuario]);


  useEffect(() => {
    const token = localStorage.getItem("token");
    if(!token){
      return setActualRol(null);
    }

      const decodedToken = parseJwt(token);
      if(decodedToken.terminosAceptados){
     
        setActualRol(decodedToken.rol);
        dispatch(controller.usuarioThunk(decodedToken.id));
      }

    
  }, []);


  function sidebarUnlogged() {
    return [];
  }

  function sidebarSuper() {
    if (localSelected && categoriaSelected) {
      const item =
        categoriaSelected === "60f806a5e3e9af972fe85c7a" ? (
          <Item
            key="Ambientes"
            text="Ambientes"
            to={`/ambientes/${localSelected}`}
            icon="fa-map-signs"
          />
        ) : (
          <Item
            key="Profesionales"
            text="Profesionales"
            to={`/profesionales/${localSelected}`}
            icon="fa-user"
          />
        );

      const itemHorarios =
        categoriaSelected === "60f806a5e3e9af972fe85c7a" ? null : (
          <Item
            key="Horarios"
            text="Horarios"
            to={`/horariosList/${localSelected}`}
            icon="fa-calendar"
          />
        );

      const itemSeguros =
        categoriaSelected === "60f7ed6a559e075075ed055a" ? (
          <Item
            key="Seguros"
            icon="fa-medkit"
            text="Seguros"
            to={`/seguros/${localSelected}`}
          />
        ) : null;

      const itemPlanes =
        categoriaSelected === "60f7f0a397887a90e7bfed2b" ? (
          <Item
            key="Planes"
            icon="fa-list-alt"
            text="Planes"
            to={`/planes/${localSelected}`}
          />
        ) : null;

      const itemSuscripciones =
        categoriaSelected === "60f7f0a397887a90e7bfed2b" ? (
          <Item
            key="Suscripciones"
            text="Suscripciones"
            icon="fa-book"
            to={`/suscripcionesByLocal/${localSelected}`}
          />
        ) : null;

      const itemContactos =
        categoriaSelected === "60f806a5e3e9af972fe85c7a" ? (
          <Item
            key="Contactos"
            text="Contactos"
            to={`/contactos/${localSelected}`}
            icon="fa-calendar"
          />
        ) : null;

      const itemAsistenciasByGroup =
        categoriaSelected === "60f806a5e3e9af972fe85c7a" ? (
          <Item
            key="asistenciasByGroup"
            text="Lista de asistencias"
            to={`/asistenciasByGroup/${localSelected}`}
            icon="fa-calendar"
          />
        ) : null;

      const itemAsistencia =
        categoriaSelected === "60f806a5e3e9af972fe85c7a" ? (
          <Item
            key="AddAsistencia"
            text="Nueva asistencia"
            to={`/addAsistencia/${localSelected}`}
            icon="fa-calendar"
          />
        ) : null;

      return [
        <UserPanel
          username={nombre}
          imageUrl={imagenPerfil}
          status={actualRol}
        />,
        <Header text={"Rol: " + actualRol} />,

        <Item
          icon="fa-cog"
          key="Editar local"
          text="Editar local"
          to={`/editLocal/${localSelected}`}
        />,
        <Item
          icon="fa-calendar"
          key="Calendario"
          text="Calendario"
          to={`/calendarioLocal/${localSelected}`}
        />,

        <Item
        icon="fa-calendar"
        key="CalendarioProfesionales"
        text="Calendario Profesionales"
        to={`/calendarioProfesionales/${localSelected}`}
      />,
        <Item
          key="Obsoletas"
          text="Reservas obsoletas"
          to={`/reservasObsoletas/${localSelected}`}
          icon="fa-thumbs-down"
        />,

        <Item
        key="Reservas"
        text="Reservas"
        to={`/reservasGeneral/${localSelected}`}
        icon="fa-thumbs-up"
      />,
        item,
        <Item
          key="Ausencias"
          text="Ausencias"
          icon="fa-plane"
          to={`/ausenciasProfesionales/${localSelected}/${categoriaSelected}`}
        />,
        <Item
          key="Subcategorias"
          text="Servicios"
          icon="fa-object-ungroup"
          to={`/subcategoriasList/${localSelected}/${categoriaSelected}`}
        />,
        itemHorarios,
        itemSeguros,
        itemPlanes,
        itemSuscripciones,
        itemContactos,
        itemAsistenciasByGroup,
        itemAsistencia,
        <Item
        key="promos"
        text="Promos"
        to={`/promociones/${localSelected}`}
        icon="fa-edit"
      />,
        <Item
          key="changePass"
          text="Editar contraseña"
          to="/editarContrasena"
          icon="fa-edit"
        />,
        <Item icon="fa-cog" key="locales" text="Ir a locales" to="/locales" />,
        <Item icon="fa-cog" key="logout" text="Cerrar sesión" to="/logout" />,
      ];
    } else {
      return [
        <UserPanel
          username={nombre}
          imageUrl={imagenPerfil}
          status={actualRol}
        />,
        <Header text={"Rol: " + actualRol} />,

        <Item
          icon="fa-envelope"
          key="invitacionesList"
          text="Invitar usuario"
          to="/crearInvitacion"
        />,

        <Item key="Locales" text="Locales" to="/locales" icon="fa-cog" />,
        <Item
          key="Sugerencias"
          text="Sugerencias"
          to="/sugerencias"
          icon="fa-comments"
        />,

        <Item
          key="listarNotificaciones"
          text="Notificaciones"
          to="/listarNotificaciones"
          icon="fa-bell"
        />,

        <Item
          key="changePass"
          text="Editar contraseña"
          to="/editarContrasena"
          icon="fa-edit"
        />,

        <Item
        key="olvidePassSuperAdmin"
        text="Editar contraseña usuarios"
        to="/olvidePassSuperAdmin"
        icon="fa-edit"
      />,

      <Item
      key="linkRegistro"
      text="Link registro"
      to="/linkRegistro"
      icon="fa-edit"
    />,

        <Item key="logout" text="Cerrar sesión" to="/logout" icon="fa-cog" />,
      ];
    }
  }
  function sidebarAdmin() {
    if (loading) {
      return [
        <UserPanel
          username={nombre}
          imageUrl={imagenPerfil}
          status={actualRol}
        />,
        <Header text={"Rol: " + actualRol} />,
      ];
    } else if (!sucursales) {
      const item =
        categoria === "60f806a5e3e9af972fe85c7a" ? (
          <Item
            key="Ambientes"
            text="Ambientes"
            to={`/ambientes/${organizacion}`}
            icon="fa-map-signs"
          />
        ) : (
          <Item
            key="Profesionales"
            text="Profesionales"
            to={`/profesionales/${organizacion}`}
            icon="fa-user"
          />
        );

      const itemHorarios =
        categoria === "60f806a5e3e9af972fe85c7a" ? null : (
          <Item
            key="Horarios"
            text="Horarios"
            to={`/horariosList/${organizacion}`}
            icon="fa-calendar"
          />
        );

      const itemContactos =
        categoria === "60f806a5e3e9af972fe85c7a" ? (
          <Item
            key="Contactos"
            text="Contactos"
            to={`/contactos/${organizacion}`}
            icon="fa-calendar"
          />
        ) : null;
      const itemAsistenciasByGroup =
      categoria === "60f806a5e3e9af972fe85c7a" ? (
          <Item
            key="asistenciasByGroup"
            text="Lista de asistencias"
            to={`/asistenciasByGroup/${organizacion}`}
            icon="fa-calendar"
          />
        ) : null;
      const itemAsistencia =
      categoria === "60f806a5e3e9af972fe85c7a" ? (
          <Item
            key="AddAsistencia"
            text="Nueva asistencia"
            to={`/addAsistencia/${organizacion}`}
            icon="fa-calendar"
          />
        ) : null;

        const itemSeguros =
        categoria === "60f7ed6a559e075075ed055a" ? (
          <Item
            key="Seguros"
            text="Seguros"
            to={`/seguros/${organizacion}`}
            icon="fa-medkit"
          />
        ) : null;

      const itemPlanes =
      categoria === "60f7f0a397887a90e7bfed2b" ? (
          <Item
            key="Planes"
            text="Planes"
            to={`/planes/${organizacion}`}
            icon="fa-list-alt"
          />
        ) : null;

        const itemSuscripciones =
        categoria === "60f7f0a397887a90e7bfed2b" ? (
          <Item
            key="Suscripciones"
            text="Suscripciones"
            to={`/suscripcionesByLocal/${organizacion}`}
            icon="fa-book"
          />
        ) : null;

      return [
        <UserPanel
          username={nombre}
          imageUrl={imagenPerfil}
          status={actualRol}
        />,
        <Header text={"Rol: " + actualRol} />,

        <Item
          key="Editar local"
          text="Editar local"
          to={`/editLocal/${organizacion}`}
          icon="fa-cog"
        />,
        <Item
          key="Calendario"
          text="Calendario"
          to={`/calendarioLocal/${organizacion}`}
          icon="fa-calendar"
        />,
        <Item
        icon="fa-calendar"
        key="CalendarioProfesionales"
        text="Calendario Profesionales"
        to={`/calendarioProfesionales/${organizacion}`}
      />,

        <Item
          key="Obsoletas"
          text="Reservas obsoletas"
          to={`/reservasObsoletas/${organizacion}`}
          icon="fa-thumbs-down"
        />,
        <Item
        key="Reservas"
        text="Reservas"
        to={`/reservasGeneral/${organizacion}`}
        icon="fa-thumbs-up"
      />,
        item,
        <Item
          key="Ausencias"
          text="Ausencias"
          to={`/ausenciasProfesionales/${organizacion}/${categoria}`}
          icon="fa-plane"
        />,
        <Item
          key="Subcategorias"
          text="Servicios"
          to={`/subcategoriasList/${organizacion}/${categoria}`}
          icon="fa-object-ungroup"
        />,
        itemHorarios,
        itemContactos,
        itemAsistenciasByGroup,
        itemAsistencia,
        itemSeguros,
        itemPlanes,
        itemSuscripciones,
        <Item
        key="promos"
        text="Promos"
        to={`/promociones/${organizacion}`}
        icon="fa-edit"
      />,
        <Item
          key="changePass"
          text="Editar contraseña"
          to="/editarContrasena"
          icon="fa-edit"
        />,
        <Item key="logout" text="Cerrar sesión" to="/logout" icon="fa-cog" />,
      ];
    } else if (sucursales && !categoriaSelected && !localSelected) {
      return [
        <UserPanel
          username={nombre}
          imageUrl={imagenPerfil}
          status={actualRol}
        />,
        <Header text={"Rol: " + actualRol} />,

        <Item
          key="Editar local"
          text="Editar local"
          to={`/editLocal/${organizacion}`}
          icon="fa-cog"
        />,
        <Item
          key="sucursales"
          text="Sucursales"
          to={`/sucursales/${organizacion}/${categoria}`}
          icon="fa-cog"
        />,

        <Item
          key="changePass"
          text="Editar contraseña"
          to="/editarContrasena"
          icon="fa-edit"
        />,
        <Item key="logout" text="Cerrar sesión" to="/logout" icon="fa-cog" />,
      ];
    } else if (sucursales && categoriaSelected && localSelected) {
      const item =
        categoriaSelected === "60f806a5e3e9af972fe85c7a" ? (
          <Item
            key="Ambientes"
            text="Ambientes"
            to={`/ambientes/${localSelected}`}
            icon="fa-map-signs"
          />
        ) : (
          <Item
            key="Profesionales"
            text="Profesionales"
            to={`/profesionales/${localSelected}`}
            icon="fa-user"
          />
        );

      const itemHorarios =
        categoriaSelected === "60f806a5e3e9af972fe85c7a" ? null : (
          <Item
            key="Horarios"
            text="Horarios"
            to={`/horariosList/${localSelected}`}
            icon="fa-calendar"
          />
        );

      const itemContactos =
        categoriaSelected === "60f806a5e3e9af972fe85c7a" ? (
          <Item
            key="Contactos"
            text="Contactos"
            to={`/contactos/${localSelected}`}
            icon="fa-calendar"
          />
        ) : null;
      const itemAsistenciasByGroup =
        categoriaSelected === "60f806a5e3e9af972fe85c7a" ? (
          <Item
            key="asistenciasByGroup"
            text="Lista de asistencias"
            to={`/asistenciasByGroup/${localSelected}`}
            icon="fa-calendar"
          />
        ) : null;

      const itemAsistencia =
        categoriaSelected === "60f806a5e3e9af972fe85c7a" ? (
          <Item
            key="AddAsistencia"
            text="Nueva asistencia"
            to={`/addAsistencia/${localSelected}`}
            icon="fa-calendar"
          />
        ) : null;

      const itemSeguros =
        categoriaSelected === "60f7ed6a559e075075ed055a" ? (
          <Item
            key="Seguros"
            text="Seguros"
            to={`/seguros/${localSelected}`}
            icon="fa-medkit"
          />
        ) : null;

      const itemPlanes =
        categoriaSelected === "60f7f0a397887a90e7bfed2b" ? (
          <Item
            key="Planes"
            text="Planes"
            to={`/planes/${localSelected}`}
            icon="fa-list-alt"
          />
        ) : null;

      const itemSuscripciones =
        categoriaSelected === "60f7f0a397887a90e7bfed2b" ? (
          <Item
            key="Suscripciones"
            text="Suscripciones"
            to={`/suscripcionesByLocal/${localSelected}`}
            icon="fa-book"
          />
        ) : null;

      return [
        <UserPanel
          username={nombre}
          imageUrl={imagenPerfil}
          status={actualRol}
        />,
        <Header text={"Rol: " + actualRol} />,

        <Item
          key="Editar local"
          text="Editar local"
          to={`/editLocal/${localSelected}`}
          icon="fa-cog"
        />,
        <Item
          key="Calendario"
          text="Calendario"
          to={`/calendarioLocal/${localSelected}`}
          icon="fa-calendar"
        />,
        <Item
        icon="fa-calendar"
        key="CalendarioProfesionales"
        text="Calendario Profesionales"
        to={`/calendarioProfesionales/${localSelected}`}
      />,
        <Item
          key="Obsoletas"
          text="Reservas obsoletas"
          to={`/reservasObsoletas/${organizacion}`}
          icon="fa-thumbs-down"
        />,
        <Item
        key="Reservas"
        text="Reservas"
        to={`/reservasGeneral/${organizacion}`}
        icon="fa-thumbs-up"
      />,
        item,
        <Item
          key="Ausencias"
          text="Ausencias"
          to={`/ausenciasProfesionales/${localSelected}/${categoriaSelected}`}
          icon="fa-plane"
        />,
        <Item
          key="Subcategorias"
          text="Servicios"
          to={`/subcategoriasList/${localSelected}/${categoriaSelected}`}
          icon="fa-object-ungroup"
        />,
        itemHorarios,
        itemSeguros,
        itemPlanes,
        itemSuscripciones,
        itemContactos,
        itemAsistenciasByGroup,
        itemAsistencia,
        <Item
        key="promos"
        text="Promos"
        to={`/promociones/${localSelected}`}
        icon="fa-edit"
      />,
        <Item
          key="changePass"
          text="Editar contraseña"
          to="/editarContrasena"
          icon="fa-edit"
        />,
        <Item
          key="sucursales"
          text="Ir a sucursales"
          to={`/sucursales/${organizacion}/${categoria}`}
          icon="fa-cog"
        />,
        <Item key="logout" text="Cerrar sesión" to="/logout" icon="fa-cog" />,
      ];
    } else {
      return [
        <UserPanel
          username={nombre}
          imageUrl={imagenPerfil}
          status={actualRol}
        />,
        <Header text={"Rol: " + actualRol} />,
      ];
    }
  }
  function sidebarOperador() {
    return [
      <UserPanel
        username={nombre}
        imageUrl={imagenPerfil}
        status={actualRol}
      />,
      <Header text={"Rol: " + actualRol} />,
      <Item
        key="Calendario"
        text="Calendario"
        to={`/calendarioLocal/${organizacion}`}
        icon="fa-calendar"
      />,
      <Item
      icon="fa-calendar"
      key="CalendarioProfesionales"
      text="Calendario Profesionales"
      to={`/calendarioProfesionales/${organizacion}`}
    />,
      <Item
        key="changePass"
        text="Editar contraseña"
        to="/editarContrasena"
        icon="fa-edit"
      />,
      <Item key="logout" text="Cerrar sesión" to="/logout" icon="fa-cog" />,
    ];
  }

  return (
    <React.Fragment>
      {/* <style>
        {`
.main-sidebar {
  width: auto !important;
}
      `}
      </style> */}

      <AdminLTE
        title={["AGENDIA"]}
        titleShort={["AGIA"]}
        theme="purple-light"
        sidebar={
          actualRol === "superadmin"
            ? sidebarSuper()
            : actualRol === "admin"
            ? sidebarAdmin()
            : actualRol === "visualizador"
            ? sidebarOperador()
            : sidebarUnlogged()
        }
      >
        <WithAuth
          path="/serviciosHijosList/:localId/:padreId/:categoriaId"
          children={ServiciosList}
        />
        <WithAuth path="/addAusencia/:id/:categoria" children={AddAusencia} />

        <WithAuth path="/crearSuscripcion/:localId" children={AddSuscripcion} />
        <WithAuth
          path="/suscripcionesByUsuario/:id/:localId"
          children={SuscripcionesByUsuario}
        />
        <WithAuth path="/editPlan/:id/:localId" children={EditPlan} />
        <WithAuth path="/crearPlan/:localId" children={AddPlan} />
        <WithAuth path="/planes/:localId" children={PlanesList} />
        <WithAuth
          path="/subirImagenesLocal/:localId"
          children={SubirImagenesLocal}
        />
        <WithAuth path="/subirImagenes" children={SubirImagenes} />
        <WithAuth path="/cortarImagenes/" children={CortarImagenesConcepto} />
        <WithAuth
          path="/editServicio/:localId/:id/:categoriaId"
          children={EditServicioHijo}
        />
        <WithAuth path="/editProfesional/:id" children={EditProfesional} />
        <WithAuth path="/editarHorario/:id" children={EditHorario} />
        <WithAuth path="/local/:id" children={Local} />
        <WithAuth path="/editLocal/:localId" children={EditLocal} />

        <WithAuth
          path="/sucursales/:localId/:categoriaId"
          children={SucursalesList}
        />
        <WithAuth path="/locales" children={LocalesList} test={"hola nestor"} />
        <WithAuth path="/sugerencias" children={SugerenciasList} />

        <WithAuth
          path="/nuevoLocal/:localId?/:categoriaId?"
          children={AddLocal}
        />
        <WithAuth path="/nuevoProfesional/:localId" children={AddProfesional} />

        <WithAuth path="/editAmbiente/:id" children={EditAmbiente} />
        <WithAuth path="/nuevoAmbiente/:localId" children={AddAmbiente} />
        <WithAuth
          path="/nuevoServicioHijo/:localId/:padreId/:categoriaId"
          children={AddServicioHijo}
        />
        <WithAuth
          path="/nuevoServicioPadre/:localId"
          children={AddServicioPadre}
        />
        <WithAuth path="/nuevoHorario/:localId" children={CargarHorario} />
        <WithAuth path="/invitacionesList" children={InvitacionesList} />

        <WithAuth path="/usuariosList/:localId" children={UsuariosList} />
        <WithAuth path="/crearInvitacion" children={CrearInvitacion} />

        <WithAuth path="/confirmacion/:invitacionId" children={Confirmacion} />
        <WithAuth
          path="/listarNotificaciones"
          children={ListarNotifTemplates}
        />
        <WithAuth path="/crearNotificacion" children={CrearNotifTemplate} />
        <WithAuth
          path="/editarNotificacion/:id"
          children={EditarNotifTemplate}
        />

        <RegistroSuper path="addUser" />
        <Registro path="/register/:token?" />
        <Logout path="/logout" />
        <Login path="/login" />
        <AceptarTerminos path="/terminos/:id" />
        <AceptarTerminos path="/terminos" />

        <ChangePass path="/editarContrasena" />
        <ChangePassByToken path="/changePass/:resetToken" />
        <WithAuth path="/landing" children={Landing} />
        <WithAuth path="/calendario" children={Calendario} />
        <WithAuth path="/calendarioLocal/:organizacion" children={Calendario} />
        <WithAuth path="/calendarioProfesionales/:organizacion" children={CalendarioProfesionales} />
        <WithAuth
          path="/profesionales/:organizacion"
          children={ProfesionalesList}
        />
        <WithAuth path="/ambientes/:organizacion" children={AmbientesList} />
        <WithAuth
          path="/ausenciasProfesionales/:organizacion/:categoria"
          children={AusenciasProfesionales}
        />
        <WithAuth
          path="/subcategoriasList/:organizacion/:categoria"
          children={ServiciosPadresList}
        />

        <WithAuth path="/horariosList/:organizacion" children={HorariosList} />
        <WithAuth
          path="/crearReserva/:organizacion"
          children={CrearReservaHorarios}
        />
        <WithAuth
          path="/crearReservaRestaurante/:organizacion"
          children={CrearReservaRestaurante}
        />
        <WithAuth path="/seguros/:organizacion" children={SegurosList} />
        <WithAuth path="/nuevoSeguro/:localId" children={AddSeguro} />
        <WithAuth path="/editSeguro/:id" children={EditSeguro} />
        <WithAuth
          path="/suscripcionesByLocal/:localId"
          children={SuscripcionesByLocal}
        />

        <WithAuth path="/reserva/:reservaId" children={ReservaDetalle} />
        <WithAuth path="/reservasObsoletas/:id" children={ReservasList} />
        <WithAuth path="/reservasGeneral/:id" children={ReservasGeneralList} />
        <WithAuth path="/editSubcategoria/:id" children={EditSubcategoria} />
        <WithAuth path="/olvidePassSuperAdmin" children={OlvidePassSuperAdmin} />
        <WithAuth path="/linkRegistro" children={LinkConfirmacionByEmail} />
        <OlvidePass path="/reestablecerPass" />
        
        <WithAuth path="/addContacto/:organizacion" children={AddContacto} />
        <WithAuth path="/editContacto/:id" children={EditContacto} />
        <WithAuth path="/addAsistencia/:localId" children={AddAsistencia} />

        <WithAuth path="/contactos/:organizacion" children={ContactosList} />

        <WithAuth
          path="/asistenciasByGroup/:organizacion"
          children={AsistenciasByGroup}
        />

        <WithAuth
          path="/asistenciasByDate/:organizacion/:fecha"
          children={AsistenciasByDate}
        />

        <WithAuth path="/promociones/:localId" children={PromosList} />
        <WithAuth path="/addPromo/:localId" children={AddPromo} />

        <WithAuth path="/" children={Landing} />
      </AdminLTE>
    </React.Fragment>
  );
}

// cambio para forzar redeploy

export default App;
